import React from "react";
import { Link } from "react-router-dom";
import villa1 from "../assets/villa1.jpg";
import villa2 from "../assets/villa2.jpg";
import chill from "../assets/chill.jpg";
import concierge from "../assets/concierge.jpg";
import park from "../assets/park.png";

const Villas = () => {
  return (
    <section id="villas">
      <h2>Community & Villas</h2>
      <div className="showcase">
        <Link to="/villa/chillout" className="showcase-item reveal">
          <img src={chill} alt="Chillout Zone" />
          <h3>Chillout Zone</h3>
          <p>
            Relaxation area with lounge seating, guest rooms, restaurant, pool,
            cafes and greenery.
          </p>
        </Link>

        <Link to="/villa/big" className="showcase-item reveal">
          <img src={villa1} alt="Big Villa" />
          <h3>Big Villa</h3>
          <p>450 m² 2 floors | 4 bedrooms, 3 bathrooms, pool, garage.</p>
        </Link>

        <Link to="/villa/medium" className="showcase-item reveal">
          <img src={villa2} alt="Medium Villa" />
          <h3>Medium Villa</h3>
          <p>400 m² 2 floors | 4 bedrooms, 3 bathrooms, pool, garage.</p>
        </Link>

        <Link to="/villa/small" className="showcase-item reveal">
          <img src={concierge} alt="Small Villa" />
          <h3>Small Villa</h3>
          <p>350 m² 2 floors | 4 bedrooms, 3 bathrooms, pool, garage.</p>
        </Link>

        <Link to="/villa/park" className="showcase-item reveal">
          <img src={park} alt="Park" />
          <h3>Park & Garden Area</h3>
          <p>Landscaped greenery and dedicated kids zone.</p>
        </Link>
      </div>
    </section>
  );
};

export default Villas;
